<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pyqWuT/tc-custom/9781504070829.jpg?1728327092984" alt="This image is the cover for the book No Crime Forgotten, The Dublin Murder Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Crime Forgotten, The Dublin Murder Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A bizarre murder in the suburbs of Dublin leads a Garda Síochána detective into a perplexing investigation in this gritty crime novel.</b><br/><br/>When Detective Garda Sergeant Mike West and his partner answer an emergency call from St. Monica’s church, they discover a dead body suspended from the beams in front of the altar. The victim is identified as Ian Moore, a man recently released from prison after serving time for rape. <br/><br/>Revenge seems like the obvious motive for Moore’s murder, but as the list of suspects grows, West begins to wonder if there’s something deeper going on. Perhaps the killer believes this is God’s work. With pressure from both the church and his boss to get the case solved quickly, West and his team have their work cut out for them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Valerie Keogh
      </h2>
      
      <p class="authorDescription body article">Valerie Keogh was born in Dublin, qualified as a nurse and then studied English in University College Dublin gaining a BA in English and a Masters in American Literature. She moved to the UK several years ago where she lives with her husband, Robert, and cat, Fatty Arbuckle. She enjoys writing both crime and psychological thrillers.  When she’s not writing, Valerie loves to travel.  You can follow Valerie on Twitter: @ValerieKeogh1  Or on Facebook: https://www.facebook.com/valeriekeoghnovels/</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b947cd2